/**
 * Links out to Google Maps.
 *
 * The `search/?api=1&query=lat,lng` form is Google's documented universal URL:
 * it opens the native app on a phone and the web map on a desktop, without
 * needing an API key or a platform check.
 *
 * Bookr stores a business as a coordinate, not a written address, so a pin is
 * all we have to hand over. That is deliberate (a map link answers "how do I
 * get there" better than a street name does), but it means the label shown
 * beside the link has to come from somewhere else.
 */
export function googleMapsHref(latitude: number, longitude: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
}

/** For an at-home visit, where we have text rather than a coordinate. */
export function googleMapsSearchHref(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
